import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ItineraryPreview from "@/components/ItineraryPreview";
import { Button } from "@/components/ui/button";
import { FileDown, Printer, Loader2 } from "lucide-react";

export default function PrintItinerary() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getItinerary(id).then(setRecord).catch(() => setRecord(null)).finally(() => setLoading(false));
  }, [id]);

  // Auto-trigger print dialog when ?autoprint=1 is in URL
  useEffect(() => {
    if (!loading && record && searchParams.get("autoprint") === "1") {
      setTimeout(() => window.print(), 800);
    }
  }, [loading, record, searchParams]);

  if (loading) return <div className="py-20 flex items-center justify-center text-slate-800"><Loader2 className="w-5 h-5 animate-spin" /></div>;
  if (!record) return <div className="py-20 text-center text-slate-800">Not found</div>;

  return (
    <div className="min-h-screen bg-transparent py-6">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex items-center justify-between mb-4 print:hidden">
          <h1 className="text-xl font-display font-semibold text-slate-800">Print Preview</h1>
          <div className="flex gap-2">
            <Button onClick={() => window.print()} variant="outline" className="rounded-xl border-slate-200 text-slate-800 hover:bg-slate-100" data-testid="print-button"><Printer className="w-4 h-4 mr-2" /> Print</Button>
            <Button onClick={() => window.print()} className="rounded-xl btn-luxe  text-white" data-testid="print-download-pdf-button"><FileDown className="w-4 h-4 mr-2" /> Download PDF</Button>
          </div>
        </div>
        <div className="bg-white shadow-2xl rounded-lg overflow-hidden ring-1 ring-white/10 itinerary-print-area">
          <ItineraryPreview record={record} />
        </div>
      </div>
      <style>{`@media print { body { background: white; } .print\\:hidden { display: none !important; } }`}</style>
    </div>
  );
}
